import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { COMMON_IMPORTS } from '../../../../Shared/common-imports';
import { HomeFacade } from '../../../../../Facades/home.facade';
import { HomeSignalRowComponent } from '../home-signal-row/home-signal-row.component';
import { HOME_ATTENTION_COLLAPSED_LIMIT, HOME_ATTENTION_SKELETON_ROWS } from '../../../Consts/home-attention.const';

@Component({
  selector: 'app-home-attention-queue',
  standalone: true,
  imports: [COMMON_IMPORTS, HomeSignalRowComponent],
  templateUrl: './home-attention-queue.component.html',
  styleUrl: './home-attention-queue.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeAttentionQueueComponent {
  readonly home = inject(HomeFacade);

  readonly skeletonRows = HOME_ATTENTION_SKELETON_ROWS;

  private readonly _expanded = signal(false);

  readonly isExpanded = this._expanded.asReadonly();

  readonly visibleSignals = computed(() =>
    this._expanded() ? this.home.signals() : this.home.signals().slice(0, HOME_ATTENTION_COLLAPSED_LIMIT)
  );

  readonly hiddenCount = computed(() =>
    Math.max(0, this.home.signals().length - HOME_ATTENTION_COLLAPSED_LIMIT)
  );

  readonly isPreparing = computed(() => this.home.isAccountLoading() && this.home.signals().length === 0);

  readonly isUnavailable = computed(() => this.home.hasAccountError() && this.home.signals().length === 0);

  readonly isAllClear = computed(
    () => !this.isPreparing() && !this.isUnavailable() && this.home.signals().length === 0
  );

  onToggle(): void {
    this._expanded.update(expanded => !expanded);
  }

  onScanFleet(): void {
    this.home.startFleetScan();
  }
}
